module.exports = __webpack_public_path__ + "img/propositions-réfusées.2765fb43.svg";